import React, { useRef } from "react";
import { Box, Paper, Typography, alpha } from "@mui/material";
import {
  CameraExportButton,
  exportComponentAsImage,
} from "../../../../utils/export/componentExporter";
import { formatAmount } from "../../../../utils/hooks/dataHandler";

const DisposalBaBcSummary = ({ bcSummary = [] }) => {
  const adjustments = bcSummary.length
    ? bcSummary
    : [{ caName: "No balancing adjustment", bcBa: 0 }];
  const exportRef = useRef(null);
  const handleExportAsImage = async (e) => {
    e.stopPropagation();
    if (exportRef.current) {
      await exportComponentAsImage(exportRef.current, "BA / (BC) Summary");
    }
  };

  return (
    <Paper
      ref={exportRef}
      elevation={0}
      sx={{
        borderRadius: 3,
        border: "1px solid",
        borderColor: "divider",
        overflow: "hidden",
        bgcolor: (theme) => alpha(theme.palette.background.paper, 0.98),
        boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
      }}
    >
      <Box
        sx={{
          p: 3,
          borderBottom: "1px solid",
          borderColor: "divider",
          bgcolor: (theme) => alpha(theme.palette.primary.main, 0.04),
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant='h6' fontWeight={600} color='primary.main'>
            BA / (BC) Summary
          </Typography>
          <CameraExportButton
            onClick={handleExportAsImage}
            tooltipTitle='Screenshot of the BA / (BC) Summary'
          />
        </Box>
      </Box>
      <Box
        component='dl'
        sx={{
          m: 0,
          p: { xs: 2, sm: 3 },
          display: "grid",
          gap: 2,
          bgcolor: (theme) => alpha(theme.palette.primary.main, 0.01),
        }}
      >
        {adjustments.map((row, index) => (
          <Box
            key={index}
            sx={{
              display: "flex",
              flexDirection: { xs: "column", sm: "row" },
              justifyContent: "space-between",
              alignItems: { xs: "flex-start", sm: "center" },
              gap: 1,
            }}
          >
            <Typography
              component='dt'
              variant='body1'
              color='text.secondary'
              fontWeight={600}
            >
              {row.caName}
            </Typography>
            <Typography
              component='dd'
              variant='h4'
              sx={{
                m: 0,
                fontWeight: 700,
                fontSize: { xs: "1.75rem", sm: "2rem" },
                fontVariantNumeric: "tabular-nums",
                color: row.bcBa === 0 ? "text.secondary" : "text.primary",
              }}
            >
              {formatAmount(row.bcBa, false)}
            </Typography>
          </Box>
        ))}
        {bcSummary.length > 1 && (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "baseline",
              gap: 2,
              pt: 2,
              borderTop: "1px solid",
              borderColor: "divider",
            }}
          >
            <Typography component='dt' fontWeight={600}>
              Total
            </Typography>
            <Typography
              component='dd'
              variant='h6'
              sx={{ m: 0, fontWeight: 700, fontVariantNumeric: "tabular-nums" }}
            >
              {formatAmount(
                bcSummary.reduce((acc, row) => acc + row.bcBa, 0),
                false
              )}
            </Typography>
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default DisposalBaBcSummary;
